import { Link } from 'react-router-dom'

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface Props {
  items: BreadcrumbItem[];
}

export default function Breadcrumb ({ items }: Props) {
  if (items.length === 0) return null

  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      <ol className="breadcrumb__list">
        {items.map((item, i) => (
          <li key={i} className="breadcrumb__item">
            {i > 0 && <span className="breadcrumb__sep" aria-hidden>›</span>}
            {item.href
              ? (
              <Link to={item.href} className="breadcrumb__link">
                {item.label}
              </Link>
                )
              : (
              <span className="breadcrumb__current">{item.label}</span>
                )}
          </li>
        ))}
      </ol>
    </nav>
  )
}
